// extracted by mini-css-extract-plugin
module.exports = {"root":"_2b459b","card":"_924faf","inner":"_1d6ca3","advisors":"_ef2c49","text":"_941e4d","heading":"_d2f7d2","description":"_8df90b"};